<template>
  <ModuleContainer v-bind="bindModule">
    <template #btn>
      <MapControlButton
        icon="mdi-map-marker-radius-outline"
        tooltip="Tọa độ định vị"
        @click="open"
      />
    </template>

    <template #draggable="props">
      <DraggablePopup
        v-bind="props"
        :height="350"
        :is-resizable="false"
        :show.sync="drag.show"
        title="Tọa độ định vị"
        :width="300"
        @close="close"
      >
        <div class="pa-2">
          <v-row class="ma-0">
            <v-col class="pb-0" cols="12">
              <field-group
                classLabel="pt-2"
                inline
                label="Loại"
                widthLabel="60px"
              >
                <template #input>
                  <v-radio-group
                    v-model="params.type"
                    hide-details
                    mandatory
                    row
                  >
                    <v-radio label="Dạng thập phân" value="xyz"></v-radio>
                    <v-radio label="Dạng độ" value="hms"></v-radio>
                  </v-radio-group>
                </template>
              </field-group>
            </v-col>
            <!-- <v-col cols="12">
              <field-group
                classLabel="pt-2"
                inline
                label="Hệ tọa độ"
                widthLabel="60px"
              >
                <template #input>
                  <v-radio-group
                    v-model="params.crs"
                    hide-details
                    mandatory
                    row
                    @change="onChangeCrs"
                  >
                    <v-radio label="VN2000" value="EPSG:3405"></v-radio>
                    <v-radio label="WGS 84" value="EPSG:4326"></v-radio>
                  </v-radio-group>
                </template>
              </field-group>
            </v-col> -->
          </v-row>
          <v-row v-if="params.type === 'xyz'" class="ma-0">
            <v-col class="pt-0" cols="12">
              <field-group
                v-model="params.xyz.lng"
                background-color="#E8ECF8"
                dense
                flat
                height="32"
                hide-details
                label="Kinh độ"
                solo
              ></field-group>
            </v-col>
            <v-col class="pt-0" cols="12">
              <field-group
                v-model="params.xyz.lat"
                background-color="#E8ECF8"
                dense
                flat
                height="32"
                hide-details
                label="Vĩ độ"
                solo
              ></field-group>
            </v-col>
          </v-row>
          <v-row v-else-if="params.type === 'hms'" class="ma-0">
            <v-col class="pt-0" cols="12">
              <field-group label="Kinh độ">
                <template #input>
                  <div class="d-flex">
                    <div>
                      <v-text-field
                        v-model="params.hms.lng.deg"
                        background-color="#E8ECF8"
                        dense
                        flat
                        height="32"
                        hide-details
                        solo
                      ></v-text-field>
                    </div>
                    <label class="px-1 text-h6">&nbsp;°</label>
                    <div>
                      <v-text-field
                        v-model="params.hms.lng.min"
                        background-color="#E8ECF8"
                        dense
                        flat
                        height="32"
                        hide-details
                        solo
                      ></v-text-field>
                    </div>
                    <label class="px-1 text-h6">&nbsp;′</label>
                    <div>
                      <v-text-field
                        v-model="params.hms.lng.sec"
                        background-color="#E8ECF8"
                        dense
                        flat
                        height="32"
                        hide-details
                        solo
                      ></v-text-field>
                    </div>
                    <label class="px-1 text-h6">&nbsp;″</label>
                  </div>
                </template>
              </field-group>
            </v-col>
            <v-col class="pt-0" cols="12">
              <field-group label="Vĩ độ">
                <template #input>
                  <div class="d-flex">
                    <div>
                      <v-text-field
                        v-model="params.hms.lat.deg"
                        background-color="#E8ECF8"
                        dense
                        flat
                        height="32"
                        hide-details
                        solo
                      ></v-text-field>
                    </div>
                    <label class="px-1 text-h6">&nbsp;°</label>
                    <div>
                      <v-text-field
                        v-model="params.hms.lat.min"
                        background-color="#E8ECF8"
                        dense
                        flat
                        height="32"
                        hide-details
                        solo
                      ></v-text-field>
                    </div>
                    <label class="px-1 text-h6">&nbsp;′</label>
                    <div>
                      <v-text-field
                        v-model="params.hms.lat.sec"
                        background-color="#E8ECF8"
                        dense
                        flat
                        height="32"
                        hide-details
                        solo
                      ></v-text-field>
                    </div>
                    <label class="px-1 text-h6">&nbsp;″</label>
                  </div>
                </template>
              </field-group>
            </v-col>
          </v-row>
          <v-col cols="12">
            <div class="d-flex justify-space-between">
              <base-button className="mr-2" @click="onSelectOnMap">
                Chọn
              </base-button>
              <base-button color="primary" @click="onFlyTo">
                Đi tới
              </base-button>
            </div>
          </v-col>
        </div>
      </DraggablePopup>
    </template>
    <slot />
  </ModuleContainer>
</template>

<script>
import { DraggablePopup } from "@components/draggable";
import { Marker } from "mapbox-gl";
import ModuleMixin from "@components/Map/mixins/ModuleMixin";
import proj4 from "proj4";

//import MapControlGroupButton from "@components/Map/control/MapControlGroupButton.vue";
//import MapControlMenuButton from "@components/Map/control/MapControlMenuButton.vue";
import MapControlButton from "@components/Map/control/MapControlButton.vue";
import { deg_to_dms, dms_to_des } from "@utils/CRS";
export default {
  components: { MapControlButton, DraggablePopup },
  props: {
    color: { type: String, default: "#DA251D" }
  },
  mixins: [ModuleMixin],
  data: (vm) => ({
    drag: { show: false },
    params: {
      type: "hms",
      crs: "EPSG:4326",
      xyz: { lat: 0, lng: 0 },
      hms: { lat: { deg: 0, min: 0, sec: 0 }, lng: { deg: 0, min: 0, sec: 0 } }
    }
  }),

  methods: {
    onInit() {},
    onDestroy() {
      this.close();
    },
    clear() {
      if (this.marker) {
        this.marker.remove();
        this.marker = null;
      }
      if (this.map) this.map.getCanvas().classList.remove("cursor-crosshair");
      this.removeListenerMap("click", "map-" + this._uid);
    },
    open() {
      this.drag.show = true;
      let center = this.map.getCenter();
      this.setValue(center);
    },
    close() {
      this.drag.show = false;
      this.clear();
    },
    onFlyTo() {
      this.convertCrsData();
      this.clear();
      this.map.flyTo({
        center: this.params.center,
        zoom: 14
      });
      this.marker = getMarkerNode({ color: this.color })
        .setLngLat(this.params.center)
        .addTo(this.map);
    },
    onSelectOnMap() {
      this.map.getCanvas().classList.add("cursor-crosshair");
      this.addListenerMap(
        "click",
        "map-" + this._uid,
        this.onMapClick.bind(this)
      );
    },
    convertCrsData() {
      if (this.params.type == "hms") {
        this.params.xyz.lat = dms_to_des(this.params.hms.lat);
        this.params.xyz.lng = dms_to_des(this.params.hms.lng);
      }

      if (this.params.crs != "EPSG:4326") {
        let point = proj4(this.params.crs, "EPSG:4326", [
          this.params.xyz.lng,
          this.params.xyz.lat
        ]);
        this.params.center = { lat: point[1], lng: point[0] };
      }
    },
    setValue(center) {
      this.params.center = center;
      if (this.params.crs != "EPSG:4326") {
        let point = proj4("EPSG:4326", this.params.crs, [
          center.lng,
          center.lat
        ]);
        center = { lat: point[1], lng: point[0] };
      }
      this.params.xyz.lat = center.lat;
      this.params.xyz.lng = center.lng;
      this.params.hms.lat = deg_to_dms(center.lat);
      this.params.hms.lng = deg_to_dms(center.lng);
    },
    onMapClick(event) {
      this.setValue(event.lngLat);
      this.clear();
      this.marker = getMarkerNode({ color: this.color })
        .setLngLat(event.lngLat)
        .addTo(this.map);
    },
    onChangeCrs() {
      this.setValue(this.params.center);
    }
  }
};

function getMarkerNode({ color } = {}) {
  const node = document.createElement("div");
  node.style.width = "12px";
  node.style.height = "12px";
  node.style.borderRadius = "50%";
  node.style.background = "#fff";
  node.style.boxSizing = "border-box";
  node.style.border = `2px solid ${color}`;
  node.style.cursor = "pointer";
  return new Marker({
    element: node,
    draggable: true
  });
}
</script>
